import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Snackbar,
  Alert
} from "@mui/material";
import axios from "../../../config/axiosConfig";

const compactFieldSx = {
  "& .MuiInputBase-root": { minHeight: 36 },
  "& .MuiInputBase-input": { py: "8px", fontSize: "0.82rem" },
  "& .MuiInputLabel-root": { fontSize: "0.82rem" },
  "& .MuiSelect-select": { py: "8px" },
};

const CAMPOS = [
  "fecha", "oficina", "descripcion", "referencia", "cod_transaccion",
  "itf", "debito", "credito", "estado", "banco", "adicional", "observacion"
];

const EditExtractoModal = ({ open, handleClose, data, onUpdated }) => {
  const [formData, setFormData] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setFormData(data || {});
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      await axios.put(`/api/extracto-historico/${formData.id}`, formData);
      setSuccessMsg("Datos actualizados correctamente ✅");
      onUpdated();
      handleClose();
    } catch (error) {
      console.error("Error al guardar:", error);
      setErrorMsg("Ocurrió un error al actualizar los datos ❌");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 800, fontSize: "1rem", py: 1.5 }}>Editar Extracto</DialogTitle>
        <DialogContent dividers sx={{ py: 1.5 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
              gap: 1.25,
            }}
          >
            {CAMPOS.map((field) => (
              field === "estado" ? (
                <FormControl key={field} size="small" fullWidth sx={compactFieldSx}>
                  <InputLabel>ESTADO</InputLabel>
                  <Select
                    name="estado"
                    value={formData.estado || ""}
                    label="ESTADO"
                    onChange={handleChange}
                  >
                    <MenuItem value="Correcto">Correcto</MenuItem>
                    <MenuItem value="No existe">Incorrecto</MenuItem>
                  </Select>
                </FormControl>
              ) : field === "fecha" ? (
                <TextField
                  key={field}
                  size="small"
                  fullWidth
                  type="date"
                  label="FECHA"
                  name="fecha"
                  value={formData.fecha?.slice(0, 10) || ""}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  sx={compactFieldSx}
                />
              ) : (
                <TextField
                  key={field}
                  size="small"
                  fullWidth
                  label={field.replace(/_/g, " ").toUpperCase()}
                  name={field}
                  value={formData[field] || ""}
                  onChange={handleChange}
                  sx={compactFieldSx}
                />
              )
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ py: 1, px: 2 }}>
          <Button size="small" onClick={handleClose} color="secondary">Cancelar</Button>
          <Button size="small" onClick={handleSave} variant="contained" disabled={saving}>
            {saving ? "Guardando..." : "Guardar"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={!!successMsg} autoHideDuration={3000} onClose={() => setSuccessMsg("")} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert severity="success" sx={{ width: "100%" }}>{successMsg}</Alert>
      </Snackbar>

      <Snackbar open={!!errorMsg} autoHideDuration={3000} onClose={() => setErrorMsg("")} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert severity="error" sx={{ width: "100%" }}>{errorMsg}</Alert>
      </Snackbar>
    </>
  );
};

export default EditExtractoModal;
